import { render, staticRenderFns } from "./ProductAddModal.vue?vue&type=template&id=047a82a9&scoped=true&"
import script from "./ProductAddModal.vue?vue&type=script&lang=js&"
export * from "./ProductAddModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "047a82a9",
  null
  
)

export default component.exports